export default function Footer() {
  const navLinks = ['Home', 'About', 'Works', 'Contact'];
  const socialLinks = [
    { icon: 'ri-instagram-line', label: 'Instagram' },
    { icon: 'ri-youtube-line', label: 'YouTube' },
    { icon: 'ri-twitter-x-line', label: 'X' },
  ];

  return (
    <footer className="relative w-full overflow-hidden" style={{ background: '#111111' }}>
      {/* Monumental background text */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 select-none pointer-events-none"
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: 'clamp(80px, 18vw, 220px)',
          fontWeight: 700,
          color: '#1A1A1A',
          lineHeight: 1,
          whiteSpace: 'nowrap',
          letterSpacing: '-0.02em',
        }}
      >
        SOYINKA
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 pt-14 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">

          {/* Col 1 — Brand */}
          <div className="flex flex-col gap-4">
            <span
              className="text-2xl font-semibold"
              style={{ fontFamily: "'Inter', sans-serif", color: '#F5F0E8' }}
            >
              Coming Soon
            </span>
            <p
              className="text-xs leading-relaxed"
              style={{ fontFamily: "'Inter', sans-serif", color: '#9A9A8A' }}
            >
              A tribute to Nigeria&apos;s most enduring literary voice.
            </p>
            <div className="flex items-center gap-3 mt-2">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  rel="nofollow"
                  aria-label={s.label}
                  className="w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer"
                  style={{
                    border: '1px solid rgba(245,240,232,0.15)',
                    color: 'rgba(245,240,232,0.4)',
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(201,168,76,0.5)';
                    (e.currentTarget as HTMLAnchorElement).style.color = '#C9A84C';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(245,240,232,0.15)';
                    (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(245,240,232,0.4)';
                  }}
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 — Nav */}
          <div className="flex flex-col gap-3">
            <span
              className="text-[10px] tracking-widest uppercase mb-1"
              style={{ fontFamily: "'Inter', sans-serif", color: '#9A9A8A' }}
            >
              Navigate
            </span>
            {navLinks.map((link) => (
              <a
                key={link}
                href="#"
                rel="nofollow"
                className="text-sm font-light transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'Inter', sans-serif", color: 'rgba(245,240,232,0.5)' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#C9A84C'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(245,240,232,0.5)'; }}
              >
                {link}
              </a>
            ))}
          </div>

          {/* Col 3 — About blurb */}
          <div className="flex flex-col gap-3">
            <span
              className="text-[10px] tracking-widest uppercase mb-1"
              style={{ fontFamily: "'Inter', sans-serif", color: '#9A9A8A' }}
            >
              About
            </span>
            <p
              className="text-sm leading-relaxed font-light"
              style={{ fontFamily: "'Inter', sans-serif", color: '#6B6B60' }}
            >
              Celebrating Nobel Laureate Wole Soyinka &mdash; playwright, poet, activist, and Nigeria&apos;s literary conscience since 1934.
            </p>
          </div>

        </div>

        {/* Bottom strip */}
        <div
          className="mt-14 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3"
          style={{ borderTop: '1px solid rgba(245,240,232,0.06)' }}
        >
          <span
            className="text-[10px] tracking-widest"
            style={{ fontFamily: "'JetBrains Mono', monospace", color: '#4A4A40' }}
          >
            &copy; {new Date().getFullYear()} timelessmemorieselasticeffects.com
          </span>
          <span
            className="text-[10px] tracking-widest"
            style={{ fontFamily: "'JetBrains Mono', monospace", color: '#4A4A40' }}
          >
            All rights reserved
          </span>
        </div>
      </div>
    </footer>
  );
}
